import { render, staticRenderFns } from "./BaseButtonWhiteExtraSmall.vue?vue&type=template&id=b3fea36a&"
import script from "./BaseButtonWhiteExtraSmall.vue?vue&type=script&lang=js&"
export * from "./BaseButtonWhiteExtraSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports